import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux'
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { ENABLE_REDUX_DEV_TOOLS } from 'src/constants'
import rootReducer from './rootReducer'
import logger from 'redux-logger'

const store = configureStore({
  reducer: rootReducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    logger,
  ],
  devTools: ENABLE_REDUX_DEV_TOOLS,
})

export const useSelector = useReduxSelector

export const useDispatch = () => useReduxDispatch()

export default store
